import React, { useId } from 'react';
import { cn } from './lib/utils';

/* Label row + native <progress> meter — parity with legacy
   `~co/common/form` Progress. Callers compose the left label (children)
   and right-side value text; display formatting stays in screens.
   `aria-labelledby` preserves the accessible name the legacy wrapping
   <label> provided. */
export function Progress({ className, children, valueText, hidden, ...props }) {
  const labelId = useId();

  return (
    <div
      hidden={hidden}
      className={cn(
        'grid grid-cols-[1fr_auto] gap-[var(--padding-small)] py-[var(--padding-mini)]',
        className,
      )}
    >
      <span id={labelId}>{children}</span>
      <span className='text-[length:var(--secondary-font-size)] text-muted-foreground'>
        {valueText}
      </span>
      <progress
        aria-labelledby={labelId}
        className='col-span-full block h-2 w-full appearance-none overflow-hidden rounded-md border-none bg-shadow-light [&::-moz-progress-bar]:bg-accent [&::-webkit-progress-bar]:bg-transparent [&::-webkit-progress-value]:bg-accent'
        {...props}
      />
    </div>
  );
}
